import {lookupProfGral} from '../../../constants/url';
import {useUtilInformation} from '../../../components/hooks/index';
import axios from 'axios';

async function useLoadLookupProfGral() {
  const {token} = useUtilInformation();
  try {
    const response = await axios.get(`${lookupProfGral}`, {
      headers: {Authorization: `Bearer ${token}`},
    });
    return response.data;
  } catch (e) {
    console.error(e); //Que hacemos con el error?
  }
}

export default useLoadLookupProfGral;
